import Component from "./TabsView";
import Tab from "./components/Tab/TabsViewTab";

interface ITabsViewExtensions {
    Tab: typeof Tab;
}

export const TabsView: typeof Component & ITabsViewExtensions = Object.assign(
    Component,
    {
        Tab,
    },
);

export type { TabViewsProps } from "./types";
